import { useState } from 'react'

export default function useToggle(defaultValue: boolean): [boolean, (value: any) => void] {
    const [value, setValue] = useState(defaultValue) 

    // allows 3 methods of toggling:
    // toggleValue(true) -> set toggle to true
    // toggleValue(false) -> set toggle to false
    // toggleValue -> set toggle to opposite of current value
    function toggleValue(value: any): void {
        setValue(currentValue => 
            typeof value === "boolean" ? value : !currentValue
        )
    }

    return [value, toggleValue]
}